import clsx from 'clsx'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'

import cl from './NumberedList.module.scss'

type PropsType = {
	data: { title: string; items: { description: string }[] }
	className?: string
}

const NumberedList: React.FC<PropsType> = ({ data, ...props }) => {
	return (
		<section className={clsx(cl.businessRequirements)} {...props}>
			<h2 className={cl.businessRequirements__title}>{data.title}</h2>
			<ol className={cl.businessRequirements__list}>
				{data.items.map((item, index) => (
					<li className={cl.businessRequirements__item} key={index}>
						{item.description && (
							<p
								className={cl.businessRequirements__description}
								dangerouslySetInnerHTML={createMarkup(item.description)}
							/>
						)}
					</li>
				))}
			</ol>
		</section>
	)
}

export default NumberedList
